var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1445_7785)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1445_7785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3788 15.8688L15.3788 1.16888L0.67887 1.16888L0.67887 15.8688L15.3788 15.8688Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1445_7785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68511 6.3626C6.68511 7.05294 6.12549 7.61259 5.43512 7.61259C4.74474 7.61259 4.18512 7.05294 4.18512 6.3626C4.18512 5.67226 4.74474 5.1126 5.43512 5.1126C6.12549 5.1126 6.68511 5.67226 6.68511 6.3626Z",
    stroke: "#86878A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34131 10.7376C9.34131 10.0473 9.90093 9.4876 10.5913 9.4876C11.2817 9.4876 11.8413 10.0473 11.8413 10.7376C11.8413 11.4279 11.2817 11.9876 10.5913 11.9876C9.90093 11.9876 9.34131 11.4279 9.34131 10.7376Z",
    stroke: "#86878A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1445_7785",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71228 12.3001L10.7663 4.8001L9.34546 4.8001L5.29138 12.3001L6.71228 12.3001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.71228 12.3001L10.7663 4.8001L9.34546 4.8001L5.29138 12.3001L6.71228 12.3001Z",
    fill: "#86878A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71228 12.3001L7.8559 12.9183L7.48735 13.6001L6.71228 13.6001L6.71228 12.3001ZM10.7663 4.8001L10.7663 3.5001L12.9468 3.5001L11.91 5.41827L10.7663 4.8001ZM9.34546 4.8001L8.20185 4.18192L8.5704 3.5001L9.34546 3.5001L9.34546 4.8001ZM5.29138 12.3001L5.29138 13.6001L3.1109 13.6001L4.14777 11.6819L5.29138 12.3001ZM5.56867 11.6819L9.62272 4.18193L11.91 5.41827L7.8559 12.9183L5.56867 11.6819ZM10.7663 6.1001L9.34546 6.1001L9.34546 3.5001L10.7663 3.5001L10.7663 6.1001ZM10.4891 5.41828L6.435 12.9183L4.14777 11.6819L8.20185 4.18192L10.4891 5.41828ZM5.29138 11.0001L6.71228 11.0001L6.71228 13.6001L5.29138 13.6001L5.29138 11.0001Z",
    fill: "#86878A",
    mask: "url(#path-4-inside-1_1445_7785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51643 1.77343L9.27527 1.28696C9.72317 0.999808 10.321 1.16 10.5654 1.63265L10.9793 2.43337C11.0587 2.58691 11.1805 2.71445 11.3301 2.80087C11.4798 2.8873 11.6512 2.92896 11.8238 2.92093L12.7242 2.87905C13.2557 2.85433 13.6934 3.29199 13.6687 3.82349L13.6268 4.72389C13.6187 4.89655 13.6604 5.06789 13.7468 5.21758C13.8333 5.36726 13.9608 5.48902 14.1143 5.56839L14.9151 5.98236C15.3877 6.22667 15.5479 6.82451 15.2608 7.27245L14.7743 8.03129C14.681 8.1768 14.6314 8.34602 14.6314 8.51886C14.6314 8.69171 14.681 8.86093 14.7743 9.00644L15.2608 9.76528C15.5479 10.2132 15.3877 10.8111 14.9151 11.0554L14.1143 11.4693C13.9608 11.5487 13.8333 11.6705 13.7468 11.8202C13.6604 11.9698 13.6187 12.1412 13.6268 12.3138L13.6687 13.2142C13.6934 13.7457 13.2557 14.1834 12.7242 14.1587L11.8238 14.1168C11.6512 14.1088 11.4798 14.1504 11.3301 14.2369C11.1805 14.3233 11.0587 14.4508 10.9793 14.6044L10.5654 15.4051C10.321 15.8777 9.72317 16.0379 9.27527 15.7508L8.51643 15.2643C8.37092 15.171 8.2017 15.1214 8.02885 15.1214C7.856 15.1214 7.68678 15.171 7.54127 15.2643L6.78243 15.7508C6.33453 16.0379 5.73665 15.8777 5.49234 15.4051L5.07837 14.6044C4.999 14.4508 4.87725 14.3233 4.72756 14.2369C4.57787 14.1504 4.40653 14.1088 4.23388 14.1168L3.33347 14.1587C2.80198 14.1834 2.36432 13.7457 2.38904 13.2142L2.43095 12.3138C2.43897 12.1412 2.3973 11.9698 2.31087 11.8202C2.22445 11.6705 2.0969 11.5487 1.94335 11.4693L1.14261 11.0554C0.669982 10.8111 0.509763 10.2132 0.79695 9.76528L1.28342 9.00644C1.3767 8.86093 1.42629 8.69171 1.42629 8.51886C1.42629 8.34602 1.3767 8.1768 1.28342 8.03129L0.79695 7.27245C0.509763 6.82451 0.669982 6.22667 1.14261 5.98236L1.94335 5.56839C2.0969 5.48902 2.22445 5.36726 2.31087 5.21758C2.3973 5.06789 2.43897 4.89655 2.43095 4.72389L2.38904 3.82349C2.36432 3.29199 2.80198 2.85433 3.33347 2.87905L4.23388 2.92093C4.40653 2.92896 4.57787 2.8873 4.72756 2.80087C4.87725 2.71445 4.999 2.58691 5.07837 2.43337L5.49234 1.63265C5.73665 1.16 6.33453 0.999808 6.78243 1.28696L7.54127 1.77343C7.68678 1.86672 7.856 1.9163 8.02885 1.9163C8.2017 1.9163 8.37092 1.86672 8.51643 1.77343Z",
    stroke: "#86878A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1445_7785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0288696 0.518829)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/Offers.8b839a823692738b7bb2e2326b823279.svg";
export { ForwardRef as ReactComponent };